import appConfig from '../../config/appConfig';
import * as httpErrorsTypes from '../../consts/app/httpErrorsTypes';
import * as scpMethods from '../../consts/scp/scpMethods';
import urlUtils from '../../utils/urlUtils';
import appInstanceService from '../app/appInstanceService';
import authDataService from '../auth/authDataService';
import * as gigyaService from '../gigya/gigyaService';
import iccService from '../icc/iccService';
import consoleLog from '../logger/consoleLogger';
import log from '../logger/log';
import {validateTokenMapping} from '../mapping/scpMappings';
import marketTypeService from '../marketTypeService';
import server from '../server/server';
import cloudWatchProvider from './cloudWatchProvider';

let credentials = null;
let isAwsCredentialsRequested = false;
let currentAwsCredentialsRequest = null;
const FAILED_FETCH_TRIES_COUNT = 3;
let failedFetchCount = 0;

const isFetchAllowed = () => failedFetchCount < FAILED_FETCH_TRIES_COUNT;

const getCredentials = async (fetchNew) => {
    if (currentAwsCredentialsRequest) {
        await currentAwsCredentialsRequest;
    } else if (fetchNew || !credentials) {
        await fetchAwsCredentials();
    }

    return credentials;
};

const getRequestConfig = async () => {
    const authToken = await authDataService.getAuthToken(true);

    if (!authToken) return;

    const appInstanceId = appInstanceService.getAppInstanceId();

    const data = {
        app_id: appConfig.getIccApiHeader_a(),
        app_instance_id: appInstanceId,
        validate_market_iso: appConfig.getIccApiHeader_m(),
        market_iso: appConfig.getScpCloudTopicMarket(),
        market_iso_prefix: appConfig.getScpCloudTopicMarketPrefix(),
    };
    const headers = {Token: authToken};

    return {data, headers};
};

const getScpApiUrl = () => urlUtils.join(appConfig.getScpApiUrl(), scpMethods.VALIDATE_SCP_TOKEN);

const fetchAwsCredentials = async () => {
    const fetchIsNotAllowed = !isFetchAllowed();

    if (fetchIsNotAllowed) return;

    const requestConfig = await getRequestConfig();

    if (!requestConfig) return;

    credentials = null;
    isAwsCredentialsRequested = true;
    const scpApiUrl = getScpApiUrl();

    try {
        currentAwsCredentialsRequest = server.post(scpApiUrl, requestConfig);
        const response = await currentAwsCredentialsRequest;

        currentAwsCredentialsRequest = null;
        isAwsCredentialsRequested = false;
        failedFetchCount = 0;

        log.debug(`fetchAwsCredentials: fetchAwsCredentials has successful response`);

        return onResponse(response);
    } catch (e) {
        if (e?.response?.status) {
            failedFetchCount = failedFetchCount + 1;
        }
        currentAwsCredentialsRequest = null;
        isAwsCredentialsRequested = false;
        consoleLog.info(`awsAuthenticationService: fetchAwsCredentials, error: ${e}`);

        return onError(e);
    }
};

const onResponse = (response) => {
    const mappedData = validateTokenMapping(response.data);

    updateCredentials(mappedData);

    return mappedData;
};

const onError = async (e) => {
    if (e?.response?.status === httpErrorsTypes.NOT_AUTHORIZED) {
        if (isAwsCredentialsRequested) return;

        const isDCE2 = marketTypeService.isDCE2();

        isAwsCredentialsRequested = true;
        if (isDCE2) {
            if (await gigyaService.refreshGigyaToken()) return;
        } else {
            await iccService.refreshIccToken({isAnonymousUserAllowed: true});

            return fetchAwsCredentials();
        }
    }
    throw e;
};

const updateCredentials = (data) => {
    credentials = data;

    cloudWatchProvider.updateCloudWatchClient(credentials);
};

export default {
    getCredentials,
};
